import React, { useEffect } from 'react';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { BaseModal } from 'components/UI';
import { useHistory } from 'react-router-dom';
import { usersActions } from 'state/modules/users';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { accountDeletionStatus } from 'constants/users';
import { FETCH_STATE } from 'constants/common';

const DeleteUserModal = ({ id, open, type, handleClick, user }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { fetchingDeleteUser, showConfirmAction, fetchedDeleteUserSuccess, fetchingDeletionUser } = useSelector(
    (state) => state.users
  );

  useEffect(() => {
    if (fetchedDeleteUserSuccess || fetchingDeletionUser === FETCH_STATE.DONE ) {
      handleClick();
      type === 'customer'
        ? history.push(buildUrl('/customers'))
        : history.push(buildUrl('/employees'));
    }

    if (showConfirmAction) {
      handleClick();
    }
  }, [fetchedDeleteUserSuccess, handleClick, dispatch, history, type, showConfirmAction]);

  /**
   * Handle delete user
   * @param {object} values Object with the value of fields of the form
   */
  const handleDeleteUser = () => {
    if (user?.deletion_status === accountDeletionStatus.REQUESTED){
      dispatch(
        usersActions.fetchDeletionUser(id, {
          deletion_status: accountDeletionStatus.ACCEPTED,
        })
      );
    } else {
      dispatch(usersActions.fetchDeleteUser(id, type));
    }
  };

  // Reset field should be shown once a error is present.
  useEffect(() => {
    return () => {
      dispatch(usersActions.resetDeletionUser());
      dispatch(usersActions.resetDeleteUser());
    };
  }, []);

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      onEnter={handleDeleteUser}
      loading={fetchingDeleteUser || fetchingDeletionUser === FETCH_STATE.LOADING}
      enterButtonLabel={i18n.t('common.confirm')}
      privileges={{ action: 'delete', subject: 'user' }}
      title={type === 'customer' ? i18n.t('customers.title_delete') : i18n.t('users.delete')}
    >
      <Box width="100%">
        <Typography variant="inherit">
          {type === 'customer'
            ? i18n.t('customers.confirm_delete')
            : i18n.t('users.confirm_delete')}
        </Typography>
      </Box>
    </BaseModal>
  );
};

DeleteUserModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['user', 'customer']),
  user: PropTypes.shape({
    deletion_status: PropTypes.string,
  }),
};

DeleteUserModal.defaultProps = {
  open: false,
  type: 'user',
  handleClick: () => {},
};

export default DeleteUserModal;
